"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Functions = require("../../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _DomEvents = require("../../utils/DomEvents");

var UIAbstractSlider = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIAbstractSlider, _PureComponent);

  function UIAbstractSlider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractSlider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAbstractSlider).call(this, props));

    _this.handleMouseDown = function (evt) {
      var _this$props = _this.props,
          onMouseDown = _this$props.onMouseDown,
          onDragStart = _this$props.onDragStart;
      (0, _Functions.callIfPossible)(onMouseDown, evt);
      if (evt.defaultPrevented) return;

      if ((0, _DomEvents.isLeftClick)(evt)) {
        _this.updatePosition(evt.clientX);

        (0, _Functions.callIfPossible)(onDragStart);

        _this.bindWindowListeners();
      }
    };

    _this.handleWindowMouseMove = function (evt) {
      _this.updatePosition(evt.clientX);
    };

    _this.handleWindowMouseUp = function () {
      var onDragEnd = _this.props.onDragEnd;
      (0, _Functions.callIfPossible)(onDragEnd);

      _this.unbindWindowListeners();
    };

    _this.refCallback = function (ref) {
      _this._el = ref;
    };

    _this.state = {
      Dragging: false
    };
    return _this;
  }

  (0, _createClass2.default)(UIAbstractSlider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindWindowListeners();
    }
  }, {
    key: "bindWindowListeners",
    value: function bindWindowListeners() {
      addEventListener('mousemove', this.handleWindowMouseMove);
      addEventListener('mouseup', this.handleWindowMouseUp);
    }
  }, {
    key: "unbindWindowListeners",
    value: function unbindWindowListeners() {
      removeEventListener('mousemove', this.handleWindowMouseMove);
      removeEventListener('mouseup', this.handleWindowMouseUp);
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(clientX) {
      var onDrag = this.props.onDrag;
      if (this._el == null) return;

      var _this$_el$getBounding = this._el.getBoundingClientRect(),
          left = _this$_el$getBounding.left,
          right = _this$_el$getBounding.right;

      if (left === right) return;
      var DragPercentX = (clientX - left) / (right - left);
      if (DragPercentX < 0) DragPercentX = 0;
      if (DragPercentX > 1) DragPercentX = 1;
      (0, _Functions.callIfPossible)(onDrag, (0, _SyntheticEvent.default)({
        percentX: DragPercentX
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          __onMouseDown = _this$props2.onMouseDown,
          __onDragStart = _this$props2.onDragStart,
          __onDragEnd = _this$props2.onDragEnd,
          __onDrag = _this$props2.onDrag,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["onMouseDown", "onDragStart", "onDragEnd", "onDrag"]);
      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        _react.default.createElement("div", Object.assign({}, rest, {
          onMouseDown: this.handleMouseDown,
          ref: this.refCallback
        }))
        /* eslint-enable jsx-a11y/no-static-element-interactions */

      );
    }
  }]);
  return UIAbstractSlider;
}(_react.PureComponent);

UIAbstractSlider.displayName = 'UIAbstractSlider';
var _default = UIAbstractSlider;
exports.default = _default;
module.exports = exports.default;